export { default } from "./useSlotProps.mjs";